import { Control, Controller } from 'react-hook-form';

import * as S from './CheckboxWithControl.styles';
import { StyledCheckboxProps } from './CheckboxWithControl.styles';

type CheckboxWithControlProps = {
  label: string;
  name: string;
  control: Control;
  checkboxValue?: string;
  formValues?: string[];
  customOnChange?: () => void;
  callback?: (checked: boolean) => void;
} & StyledCheckboxProps;

export function CheckboxWithControl(props: CheckboxWithControlProps): React.ReactElement {
  const {
    label,
    name,
    disabled = false,
    control,
    checkboxValue,
    formValues = [],
    customOnChange = undefined,
    callback = undefined,
  } = props;

  return (
    <S.Container disabled={disabled}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <S.Checkbox
            checked={value?.includes(checkboxValue)}
            disabled={disabled}
            type="checkbox"
            value={value}
            id={name}
            onChange={(e) => {
              if (customOnChange) {
                customOnChange();
                return;
              }
              let valueCopy = [...formValues];

              if (e.target.checked && checkboxValue) {
                valueCopy.push(checkboxValue);
              } else {
                valueCopy = valueCopy.filter((el) => el !== checkboxValue);
              }

              onChange(valueCopy.filter((valueItem: string) => valueItem));

              if (callback) {
                callback(e.target.checked);
              }
            }}
          />
        )}
      />

      {label ? <S.Label>{label}</S.Label> : null}
    </S.Container>
  );
}
